<template>
  <div class="text-xs-center pt-3">
    <span class="order-text-pagename elevation-2">Complete</span>
    <transition name="slide-x-reverse-transition" mode="out-in">
      <orderListTable
        :filterDate="true"
        :fetching_order="isLoading"
        :dateTimeDineIn="dateTimeDineIn"
        :orderList="orderList"
        @onSelectDateTimeDineIn="
          dateTimeDineIn = $event;
          fetchData();
        "
      ></orderListTable>
    </transition>
  </div>
</template>

<script>
import orderListTable from "@/components/back-office/DineIn/Order/OrderTable.vue";
import { mapActions } from "vuex";

export default {
  computed: {},
  components: {
    orderListTable,
  },
  data() {
    return {
      interval_order_complete: null,
      dateTimeDineIn: new Date().toISOString().substr(0, 10),
      orderList: [],
      isLoading: false,
    };
  },
  methods: {
    ...mapActions({ fetchOrderList: "fetchDineIn/fetchOrderList" }),
    async getData() {
      await this.fetchData();
      let vm = this;
      this.interval_order_process = setInterval(async function() {
        vm.fetchData();
      }, 60000);
    },
    async fetchData() {
      this.isLoading = true;
      let result = await this.fetchOrderList({
        order_status: [3],
        datetime_dine_in: this.dateTimeDineIn,
      });
      this.isLoading = false;
      if (result == false) return;
      this.orderList = result;
      return;
    },
  },
  beforeDestroy() {
    clearInterval(this.interval_order_complete);
  },
  mounted() {
    this.getData();
    const path = [
      {
        text: "Complete list",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style scoped></style>
